<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <div class="form-group col-md-12 mp-5">
        <input class="form-control" placeholder="Buscar.. " 
        [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged()"  #quickFilter />

        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]      ="DAT_AG_GRID.id" 
                        [class]   ="DAT_AG_GRID.class" 
                        [ngStyle] ="DAT_AG_GRID.style" 
                        [rowData] ="rowData" 
                        [sideBar] ="true"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        
                        [pagination]="DAT_AG_GRID.pagination" 
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
        </ag-grid-angular>
      </div>
      <!-- GRILLA [cellSelection]="true" -->
    </ng-template>
  </div>
  
    <!-- MODAL  -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>

    <ng-template #abrirModal>
        <div class="container-fluid">

            <form [formGroup]="formulario" mat-dialog-content>
                <div class="row">
                    <div class="col form-group">
                        <app-lfsa-input formControlName="id" [label]="'* ID Marquesina'" [id]="'id'" 
                        [control]="formulario.get('id')" [type]="'text'" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col form-group">
                        <app-lfsa-input formControlName="codigo" [label]="'* Codigo interno api marquesina'" 
                        [id]="'codigo'" [control]="formulario.get('codigo')" [type]="'text'">
                        </app-lfsa-input>
                    </div>
                    <div class="col form-group">
                        <label for="">* Ubicación fisica</label>
                        <select class="form-control" formControlName="ubicacion" name="ubicacion">
                          <option value="">-- seleccione --</option>
                          <option value="PUERTA">PUERTA EXTERNA</option>
                          <option value="BALANZA_IN">BALANZA_IN</option>
                          <option value="BALANZA_OUT">BALANZA_OUT</option>
                        </select>
                    </div>
                    
                </div>

                <app-lfsa-botones-formulario 
                    (devolverAccion)  = "acciones( $event )" 
                    [formularioValido] = "formulario.invalid" 
                    [loading]="loading" 
                    [textBoton]="'Guardar'"  class="row p-3 mt-3">
                </app-lfsa-botones-formulario>
            </form>
        </div>
    </ng-template>
    <!-- END MODAL --> 